class AccountSettings.MarketingAccountsView extends Backbone.View
  template: JST["backbone/templates/account_settings/topics/marketing_accounts"]
  className: 'marketing-account-selection-container'
  events:
    'click .add-new-marketing-account': 'onClickAddMarketingAccount'

  initialize: (@options = {}) ->
    @marketingAccounts = @options.marketingAccounts
    @alreadySelectedAccounts = @options.selectedAccounts
    @sourceIndex = @options.sourceIndex
    @marketingAccountSelectorView = new AccountSettings.MarketingAccountSelectorView({marketingAccounts: @marketingAccounts})
    @accountsListView = new AccountSettings.MarketingAccountListView()

  render: =>
    @$el.html(@template(@))
    @$el.find('.marketing-accounts-dropdown-selector-container').append(@marketingAccountSelectorView.render().el)
    @$el.find('.marketing-accounts-dropdown-selector-container').hide()
    @$el.find('.marketing-accounts-list-container').append(@accountsListView.render().el)
    @bindMarketingAccountSelectorAddAndClose()
    @renderAlreadySelectedMarketingAccounts()
    @

  onClickAddMarketingAccount:->
    @$el.find('.add-new-marketing-account').hide()
    @$el.find('.marketing-accounts-dropdown-selector-container').show()

  bindMarketingAccountSelectorAddAndClose: ->
    @marketingAccountSelectorView.bind('marketing-account:selector:click:close', @onClickClose)
    @marketingAccountSelectorView.bind('marketing-account:click:add', @onClickAdd)

  onClickClose:=>
    @$el.find('.marketing-accounts-dropdown-selector-container').hide()
    @$el.find('.add-new-marketing-account').show()

  onClickAdd:(marketingAccount) =>
    selectionView = new AccountSettings.MarketingAccountSelectionView({marketingAccount: marketingAccount, sourceIndex: @sourceIndex})
    @accountsListView.addNewSelection(selectionView)

  renderAlreadySelectedMarketingAccounts:=>
    _.each(@alreadySelectedAccounts, (marketingAccount)=>
      account = {accountName: marketingAccount.name, accountId: "#{marketingAccount.id}"}
      @onClickAdd(account)
    )
